import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Lang, Tld } from '../../typings/common';
import { ScopedPopup } from '../ScopedPopup/ScopedPopup';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';
import { Tableau } from '../Tableau/Tableau';

import './ServicesMenu.css';

export interface ServicesMenuProps {
    cls?: string;
    lang: Lang;
    tld: Tld;
}

export interface ServicesMenuState {
    isOpen: boolean;
}

export class ServicesMenu extends React.PureComponent<ServicesMenuProps, ServicesMenuState> {
    constructor(props: ServicesMenuProps) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    render() {
        const { cls, lang, tld } = this.props;

        return (
            <div className={classNames('services-menu', cls)} onClick={this.onActionsSelectorBtnClick}>
                <a
                    href="//www.yandex.ru/all"
                    tabIndex={0}
                    className={Bem.cls({
                        block: 'services-menu',
                        elem: 'switcher',
                        mods: { active: this.state.isOpen }
                    })}
                >
                    <Shape2
                        cls={Bem.cls('services-menu', 'switcher-icon')}
                        icon={Shape2Icon.burger}
                        width={16}
                        height={16}
                    />
                </a>

                <ScopedPopup
                    theme="normal"
                    target={'anchor'}
                    anchor={this}
                    directions={['bottom-left']}
                    autoclosable={true}
                    hasTail={true}
                    visible={this.state.isOpen}
                    onOutsideClick={this.onActionsSelectorOutsideClick}
                    zIndexGroupLevel={4001}
                >
                    <Tableau lang={lang} domain={tld} />
                </ScopedPopup>
            </div>
        );
    }

    private onActionsSelectorBtnClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();

        this.setState({
            isOpen: !this.state.isOpen
        });
    };

    private onActionsSelectorOutsideClick = () => {
        this.setState({ isOpen: false });
    };
}
